import { siteInfo } from '@/mocks/homeMocks';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-16"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 text-xs bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                免费漫画
              </span>
              <span className="px-3 py-1 text-xs bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap">
                下拉式阅读
              </span>
              <span className="px-3 py-1 text-xs bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                每日更新
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              {siteInfo.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              {siteInfo.intro}
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl text-primary-500 whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                开始阅读热门漫画
              </a>
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="px-8 py-3 border border-background-300 text-foreground-700 rounded-full text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                探索话题分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20colorful%20manga%20and%20comic%20illustration%20featuring%20various%20art%20styles%20blending%20together%2C%20Korean%20webtoon%20Japanese%20manga%20and%20Chinese%20manhua%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20warm%20coral%20and%20amber%20color%20palette%2C%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20energetic%20composition%2C%20modern%20digital%20illustration%2C%20clean%20gradient%20background%2C%20professional%20quality%20artwork&width=800&height=700&seq=hero-main-visual&orientation=portrait"
                alt="虫虫漫画网 - 免费漫画在线阅读平台"
                className="w-full h-auto max-h-[500px] object-contain"
                width="800"
                height="700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}